exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lm-workspace{position:absolute!important;height:100%;left:176px;right:400px}.lm-container{position:relative;width:910px;margin:auto;padding-left:15px}", ""]);

// exports
